import { announceMessage } from '../accessibility/status-messages';
import { validate, validateByType, positionWindowAtFormElement, removeAllErrors } from '../../utils/form-validation-utils';
import { createAccount } from './account-api';
import { checkLoginStatus } from './login';

const addCreateAccountCallbacks = (callbacks) => {
  window.onSubmitCallbacks = callbacks;
};

const removeCreateAccountCallbacks = () => {
  window.onSubmitCallbacks = null;
};

const setCreateAccountFocus = (options) => {
  const { form } = options;
  const username = form.querySelector('[name="acctUsername"]');
  if (username) {
    setTimeout(() => {
      username.focus();
    }, 0);
  }
};
const passwordMatch = (passIpt, passConfirmIpt) => {
  // console.log(`${passIpt.value}/${passConfirmIpt.value}`);
  if (passIpt.value === passConfirmIpt.value) {
    return true;
  }
  return false;
};

const passwordStrength = (passIpt, passConfirmIpt) => {
  // console.log(`${passIpt.value}/${passConfirmIpt.value}`);
  if (passIpt.value === '' && passConfirmIpt.value === '') {
    return true; // ignore
  }
  if (validateByType('password', passIpt.value) && validateByType('password', passConfirmIpt.value)) {
    return true;
  }
  return false;
};

const resetCreateAccountForm = (options) => {
  const { form } = options;
  const errorMsg = form.querySelector('.password-mismatch-error-message');
  const existingErrorMsg = form.querySelector('.existing-account-error-message');
  const accountCreationErrorMsg = form.querySelector('.account-creation-error-message');
  const passwordStrengthErrorMsg = form.querySelector('.password-strength-error-message');
  const username = form.querySelector('[name="acctUsername"]');
  const passIpt = form.querySelector('[name="acctPassword"]');
  const passConfirmIpt = form.querySelector('[name="acctPasswordConfirm"]');
  username.value = '';
  passIpt.value = '';
  passConfirmIpt.value = '';
  form.querySelector('[name="offer-opt-in"]').checked = true;
  // Remove errors
  errorMsg.classList.add('hide');
  existingErrorMsg.classList.add('hide');
  accountCreationErrorMsg.classList.add('hide');
  passwordStrengthErrorMsg.classList.add('hide');
  removeAllErrors(form);
};

const init = (options) => {
  const { form, disableScroll } = options;
  const errorMsg = form.querySelector('.password-mismatch-error-message');
  const existingErrorMsg = form.querySelector('.existing-account-error-message');
  const accountCreationErrorMsg = form.querySelector('.account-creation-error-message');
  const passwordStrengthErrorMsg = form.querySelector('.password-strength-error-message');
  const username = form.querySelector('[name="acctUsername"]');
  const passIpt = form.querySelector('[name="acctPassword"]');
  const passConfirmIpt = form.querySelector('[name="acctPasswordConfirm"]');
  const submitBtn = form.querySelector('.submit-btn');

  const updateModalHeight = () => {
    const modalDiv = document.querySelector('#acct-login-modal');
    const contentHeight = modalDiv.querySelector('.modal-content').offsetHeight;
    modalDiv.querySelector('.modal-panel').style.height = `${contentHeight + 30}px`;
  };

  submitBtn.addEventListener('click', (event) => {
    event.preventDefault();
    const { onSubmitCallbacks } = window;
    passIpt.parentNode.classList.remove('ValidationFail');
    passConfirmIpt.parentNode.classList.remove('ValidationFail');
    errorMsg.classList.add('hide');
    existingErrorMsg.classList.add('hide');
    accountCreationErrorMsg.classList.add('hide');
    passwordStrengthErrorMsg.classList.add('hide');
    if (validate(form) && passwordMatch(passIpt, passConfirmIpt)) {
      // Unhecked/checked opt-in map to 0/1
      let optInVal = 0;
      if (form.querySelectorAll('[name="offer-opt-in"]:checked').length === 1) {
        optInVal = 1;
      }
      createAccount(
        {
          username: username.value,
          password: passIpt.value,
          'marketing-opt-in': optInVal,
          'microsite-name': window.micrositeName,
        },
        {
          onSuccess: (data) => {
            // console.log(data);
            if (data['user-id'] === 0 || data['user-id'] === '0') {
              existingErrorMsg.classList.remove('hide');
              announceMessage(existingErrorMsg.innerHTML);
            } else if (data['user-id'] === -1) {
              accountCreationErrorMsg.classList.remove('hide');
              announceMessage(accountCreationErrorMsg.innerHTML);
            } else {
              window.isAuthenticated = true;
              window.userId = data['user-id'];
              checkLoginStatus(() => {
                if (onSubmitCallbacks) {
                  onSubmitCallbacks.onLoginSuccess();
                } else {
                  window.location = `${window.myAccountUrl}?newaccount=true`;
                }
              });
            }
          },
          onError: (data) => {
            console.log(data);
            accountCreationErrorMsg.classList.remove('hide');
            announceMessage(accountCreationErrorMsg.innerHTML);
            if (onSubmitCallbacks) {
              onSubmitCallbacks.onLoginFail();
            }
          },
        },
      );
    } else if (!passwordMatch(passIpt, passConfirmIpt)) {
      passIpt.parentNode.classList.add('ValidationFail');
      passConfirmIpt.parentNode.classList.add('ValidationFail');
      errorMsg.classList.remove('hide');
      announceMessage(errorMsg.innerHTML);
      // Don't run if in modal
      // console.log(`create-account.js, disableScroll: ${disableScroll}`);
      if (!disableScroll) {
        positionWindowAtFormElement({
          element: form.parentNode,
          offset: -75,
        });
      } else {
        updateModalHeight();
      }
    } else {
      // Don't run if in modal
      if (!disableScroll) {
        positionWindowAtFormElement({
          element: form.parentNode,
          offset: -75,
        });
      } else {
        updateModalHeight();
      }
      if (!passwordStrength(passIpt, passConfirmIpt)) {
        passwordStrengthErrorMsg.classList.remove('hide');
        announceMessage(passwordStrengthErrorMsg.innerHTML);
      }
    }
  });
};

export {
  addCreateAccountCallbacks,
  removeCreateAccountCallbacks,
  init,
  resetCreateAccountForm,
  setCreateAccountFocus,
};
/* eslint-enable no-console */
